import Axios from "@/models/axios";
import NewsFeedConfig from '@/configs/news-feed';

class NewsFeedApi extends Axios {
  path() {
    return `papi/NewsFeed/${NewsFeedConfig.UNIQUE_IDENTIFIER_API_KEY}`
  }
}

export default NewsFeedApi;
